import {CampaignNotiPage} from './CampaignNotiPage';
export default CampaignNotiPage;